<template>
  <div class="item-box disFlex v" :class="{ 'red-bgc-r': stylecolor }">
    <div
      v-if="item.maxAmount > 0"
      class="item-right-tag"
      :class="{ 'red-bgc-r2': stylecolor, 'red-c': stylecolor }"
    >
      最高减免
    </div>
    <div class="disFlex Flex-center">
      <div class="img-box">
        <img :src="item.brandLogo" class="item-img" />
      </div>
      <div class="item-body">
        <img
          src="https://j.weizan.cn/youxiang/coupon-used.png"
          class="used-img"
          v-if="item.used"
        />

        <div class="item-data fc">
          <div class="item-title clamp1">{{ item.name }}</div>
        </div>
      </div>
      <div class="item-right disFlex vertical fc fvc">
        <div class="price" :class="{ 'red-c': stylecolor }" v-if="item.maxAmount > 0">
          ￥{{ item.maxAmount }}
        </div>
        <div
          class="tip"
          :class="{ 'red-c': stylecolor }"
          v-if="!item.used && buy && source !== 'couponDetail'"
          @click="use"
        >
          立即使用
        </div>

        <div
          class="tip"
          :class="{ 'red-c': stylecolor }"
          v-if="item.used && buy && source !== 'couponDetail'"
          @click="viewDetail"
        >
          查看详情
        </div>
      </div>
    </div>
    <!-- <div class="newrule f fbt">
      <div :class="{ clamp1: !showcoupon }">{{ computedRule }}</div>
      <div
        v-if="showcoupon && computedRule && computedRule.length > 32"
        @click="showCouponDetail(true)"
      >
        <van-icon name="arrow-down" />
      </div>
      <div
        v-if="!showcoupon && computedRule && computedRule.length > 32"
        @click="showCouponDetail(false)"
        style="margin-left: 10px"
      >
        <van-icon name="arrow-up" />
      </div>
    </div> -->
    <van-divider  
    :style="{ color: 'rgba(0, 48, 120, 0.1)', borderColor: 'rgba(0, 48, 120, 0.1)', padding: '0 16px' }" />
    <div class="f v ruleshow">
      <div class="newrule f fbt" :class="{ hiderule: !showcoupon && item.preferenceType === 1, hiderule2: !showcoupon && item.preferenceType === 2 }">
        <div class="f fw">
          <template v-if="item.preferenceType === 1">
            <div
                v-for="(item, index) in computedRuleArray"
                class="minwidth"
                :key="index"
            >
              {{ item }}
            </div>
          </template>
          <div v-else>{{item.preferenceContent }}</div>
        </div>
        <div v-if="!showcoupon" @click="showCouponDetail(false)">
          <van-icon name="arrow-down" />
        </div>
      </div>
      <div class="hidebutton" v-if="showcoupon" @click="showCouponDetail(true)">
        收起
      </div>
    </div>
    <van-dialog
      v-model="showqrcode"
      :close-on-click-overlay="stylecolor"
      :show-confirm-button="false"
    >
      <div style="width: 80%; margin: 10px auto">
        <img :src="qrcode" style="width: 100%" alt="图片加载中，请稍后" />
        <div class="tip">出示给导购员进行扫码核销</div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
    tradeNo: {
      type: Number,
      default: 0,
    },
    buy: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: "",
    },
    stylecolor: {
      type: Boolean,
      default: true, //风格默认红色
    },
  },
  computed: {
    // computedRule: function () {
    //   let tmp = "";
    //   this.item.rule.forEach((i) => {
    //     tmp += `满${i[0]}-${i[1]}  `;
    //   });
    //   return tmp;
    // },
    computedRuleArray () {
      let tmparray = [];
      if (this.item.preferenceType === 1) {
        this.item.rule.forEach((i) => {
          tmparray.push(`满${i[0]}-${i[1]}`);
        });
      }
      return tmparray;
    },
  },
  data() {
    return {
      showqrcode: false,
      qrcode: "",
      showcoupon: false,
    };
  },
  methods: {
    use() {
      this.$http
        .get("/v1/qrcode/gen_code", {
          scene: "card_finish",
          addition: encodeURIComponent(
            JSON.stringify({
              tradeNo: this.tradeNo,
              id: this.item.id,
              userId: localStorage.getItem("user_id"),
            })
          ),
        })
        .then((res) => {
          this.qrcode = res.data.qrcodePath;
          this.showqrcode = true;
        });
    },
    viewDetail() {
      const that = this;
      that.$dialog({
        title: "使用详情",
        message: `核销时间：${that.item.finishTime}\n\n核销导购员：${
          that.item.kpiUserName
        }\n\n核销门店：${that.item.kpiUserShop || "-"}\n\n核销品牌：${
          that.item.kpiUserBrand || "-"
        }\n\n转单金额：${that.item.changeAmount}`,
      });
    },
    showCouponDetail(val) {
      const that = this;
      this.showcoupon = !val;
    },
  },
};
</script>
<style lang="less" scoped>
.red-bgc {
  background: #b80000 !important;
}
.red-bgc-r {
  background: rgb(254, 242, 242) !important;
}
.red-bgc-r2 {
  background: rgb(247, 217, 217) !important;
}
.red-bgc-light {
  background: rgba(184, 0, 0, 0.6) !important;
}
.red-c {
  color: #b80000 !important;
}
.white-c {
  color: #ffffff !important;
}
.red-linear {
  background: linear-gradient(90deg, #9b0000, #b80000, #9b0000) !important;
}
.red-boxs {
  box-shadow: 0px 10px 11px 0px rgba(184, 0, 0, 0.68) !important;
}
.item-box {
  width: 345px;
  margin: 15px auto 0;
  // height: 75px;
  background: #f2f4f8;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 15px;
  position: relative;
  border-radius: 5px;
  .item-right-tag {
    width: 60px;
    height: 17px;
    background: rgba(0, 48, 120, 0.1);
    border-radius: 0px 8px 0px 8px;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 10px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 17px;
    text-align: center;
    color: rgba(0, 48, 120, 1);
  }
  .item-right {
    width: 80px;
  }
  .item-data {
    height: 45px;
  }
  .img-box {
    width: 60px;
    height: 45px;
    background: rgba(216, 216, 216, 1);
    border-radius: 1px;
    .item-img {
      width: 60px;
      height: 45px;
      background: rgba(216, 216, 216, 1);
      border-radius: 1px;
    }
  }
  .used-img {
    width: 60px;
    height: 60px;
    position: absolute;
    top: -12px;
    left: 100px;
  }
  .item-body {
    position: relative;
    margin-left: 10px;
    width: 177px;
    border-right: 1px dashed rgba(0, 48, 120, 0.1);
    .item-title {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
      line-height: 24px;
    }
    .rule {
      line-height: 20px;
    }
    .item-info {
      display: inline-block;
      font-size: 10px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(116, 116, 116, 1);
    }
  }
  .item-right {
    padding: 10px 10px 0;
    margin-top: 5px;
    .tip {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(0, 48, 120, 1);
      margin-top: 5px;
    }
  }
  .price {
    font-size: 17px;
    font-family: DIN;
    font-weight: bold;
    color: rgba(0, 48, 120, 1);
  }
}
.newrule {
  line-height: 20px;
  font-size: 14px;
  margin-top: 5px;
}
.newrule2 {
  height: 25px;
}
.minwidth {
  min-width: 80px;
  margin-right: 15px;
  margin-bottom: 10px;
  padding: 0 2px;
  border-radius: 5px;
  border: 1px solid #013077;
  color: #013077;
}
.hiderule {
  height: 30px;
  overflow: hidden;
}
.hiderule2 {
  height: 20px;
  overflow: hidden;
}
.ruleshow {
  align-items: center;
}
.hidebutton {
  width: 50px;
  height: 14px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #013077;
  text-align: center;
  margin: 10px 0;
}
.dividerline{
}
</style>